import { apiUri } from '@/constants/Constants';
import { client } from '@/utils/axios/axiosClient';
import { RenterInviteType } from '@/utils/types/renter.interface';
import { User } from '@/utils/types/User';
import { QueryClient } from '@tanstack/react-query';

export const updateRenterInviteType = async (
  queryClient: QueryClient,
  renterInviteType: RenterInviteType,
) => {
  return client
    .patch(apiUri.updateRenterInviteType, { renterInviteType }, { withCredentials: true })
    .then(() => {
      queryClient.setQueryData(['user'], (oldData: User | undefined) =>
        oldData ? { ...oldData, renterInviteType } : oldData,
      );
    })
    .catch((error) => console.error('Failed to update renter invite type:', error));
};
